export default "__VITE_ASSET__COauz8gj__"